import styled from '@emotion/styled'

const Container = styled.a`
  & {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-flow: column nowrap;
    color: ${({ theme }) => theme.colors.gray[900]};
    line-height: normal;
    transition: ${({ theme }) => theme.style.transitionTime[400]} opacity;
  }

  &:hover {
    opacity: ${({ theme }) => theme.style.opacity[700]};
  }

  &:focus {
    opacity: ${({ theme }) => theme.style.opacity[500]};
  }

  & > * {
    margin: 0 0 16px 0;
  }

  figure {
    position: relative;
    padding: 52.27% 0 0 0;
    width: 100%;
  }

  figure > * {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  h1 {
    font-size: var(--fs-300);
    font-weight: 500;
  }

  p {
    font-size: var(--fs-50);
    font-weight: 300;
  }
`

export default Container
